<template>
    <section>
        <div class="page-wrap">
            <div class="container">
                <div class="box-content">
                    <h2>Legacy Brick Options</h2>
                    <div>
                        <p>
                            Click on your preferred brick to enter and view your inscription as it will appear in the plaza.
                            You will also have an opportunity to order a Certificate of Recognition or
                            a replica of your brick for yourself and loved ones to enjoy at home or in the office!
                            To place an order outside of the contiguous United States (International, Alaska or Hawaii),
                            please call us at 1-833-668-8633.
                        </p>
                        <p>Premium location bricks will be installed in a featured location in the central heart of Indian Creek Plaza.</p>
                    </div>
                    <catalog></catalog>
                </div>
            </div>
        </div>
    </section>
</template>

<script type="text/jsx">
    import Catalog from './shop/Catalog.vue';
    export default {
        name: 'shop',
        props: {
        },
        mixins: [
        ],
        data: function () {
            return this.getDefaultData();
        },
        components: {
            'catalog': Catalog
        },
        created: function () {
        },
        methods: {
            getDefaultData: function () {
                return {
                }
            }
        }
    }
</script>

<style>
</style>



// WEBPACK FOOTER //
// Shop.vue?08c5f287